import angular from 'angular';
import './icon.styl';

export default angular
  .module('ui.local.icon', [])
  .directive('localUiIcon', ['$compile', ($compile) => ({
    replace: true,
    scope: {
      name: '@'
    },
    link(scope, element) {
      const iconWrapper = document.createElement('div');
      const iconSource = require(`./icons/${scope.name}.svg?raw`);
      iconWrapper.innerHTML = iconSource;

      const icon = iconWrapper.querySelector('svg');
      icon.setAttribute('class', `cui-icon cui-icon_${scope.name}`);

      element.html(icon.outerHTML);

      $compile(element.contents())(scope);
    }
  })])
  .name;
